export const authRoutes = [
  {
    path: 'signin',
    name: 'signIn',
    component: () => import('@/views/auth/SignIn'),
    meta: {
      title: 'Sign In',
      auth: false
    }
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('@/views/auth/ForgotPassword'),
    meta: {
      title: 'Quên mật khẩu',
      auth: false
    }
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/views/auth/ResetPassword'),
    meta: {
      title: 'Tạo lại mật khẩu',
      auth: false
    }
  }
]
